module.exports = __webpack_public_path__ + "static/media/BuiltSmartSlide04.3e30aec4.jpg";